import { computed } from '@ember/object';

export let modelProfileId = {
  profileId: computed('publicLinkId', function () {
    return this.publicLinkId;
  }),
};
